import { Combobox, ComboboxInput, type ComboboxInputProps } from '@zillow/constellation';
import type React from 'react';

/**
 * Constellation Combobox has a bug that prevents the onBlur callback to be
 * passed to the input component. This prevents combobox fields to be
 * validated when the form validation mode is "onBlur". This is a workaround.
 */

export function ComboBoxFix({ onBlur, ...props }: React.ComponentProps<typeof Combobox>) {
  return (
    <Combobox
      {...props}
      renderInput={(inputProps: ComboboxInputProps & { onBlur?: React.FocusEventHandler<HTMLInputElement> }) => (
        <ComboboxInput
          {...(inputProps as React.ComponentProps<typeof ComboboxInput>)}
          onBlur={(ev) => {
            inputProps.onBlur?.(ev);
            onBlur?.(ev);
          }}
        />
      )}
    />
  );
}
